import React from 'react';

import { Section, Grid } from '@gogame/components';
import { FormField, withForm, SidePageV2 } from '@gogame/form';

import {
  EditGranularityProvider,
  EDIT_GRANULARITY_ALL,
  useCanEdit,
  useCanEditAll,
} from 'scenes/CustomAudiences/EditGranularityContext';
import { loadOwners } from 'scenes/CustomAudiences/PartnerAudiences/sources/fields';

import { NAME, OWNER } from './constants';
import { singleAudienceValidationSchema } from './schemas';

const EDIT_GRANULARITY_OWNER = 'Owner';
const EDIT_GRANULARITY_NAME = 'Name';

const SinglePartnerAudienceForm = withForm({
  validationSchema: singleAudienceValidationSchema,
  enableReinitialize: true,
})(({ children, title, onClose, onExited, open, loading, values }) => {
  const canEditOwner = useCanEdit(EDIT_GRANULARITY_OWNER);
  const canEditName = useCanEdit(EDIT_GRANULARITY_NAME);
  const canEditAll = useCanEditAll();
  return (
    <SidePageV2
      onClose={onClose}
      onExited={onExited}
      loading={loading}
      open={open}
      size={'md'}
    >
      <SidePageV2.Title
        title={title}
        subTitle={values.name}
        entityId={values.id}
      />
      <SidePageV2.NewBody scroll={false}>
        <Section title={'GG Audience'} isCollapsable={false} initialOpen={true}>
          <Grid spacing={3} container>
            <Grid item xs={12}>
              <FormField.TextField
                label={'Name'}
                name={NAME}
                padding={0}
                required={true}
                disabled={!canEditName && !canEditAll}
              />
            </Grid>
            <Grid item xs={6}>
              <FormField.Select
                padding={0}
                label={'Owner'}
                name={OWNER}
                source={loadOwners}
                disabled={!canEditOwner && !canEditAll}
              />
            </Grid>
          </Grid>
        </Section>
      </SidePageV2.NewBody>

      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton />
      </SidePageV2.Actions>
      {children}
    </SidePageV2>
  );
});

export default function SinglePartnerAudienceFormWithEditGranularity({
  editGranularity = EDIT_GRANULARITY_ALL,
  ...props
}) {
  return (
    <EditGranularityProvider editGranularity={editGranularity}>
      <SinglePartnerAudienceForm {...props} />
    </EditGranularityProvider>
  );
}
